import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {of} from 'rxjs';
import {map, catchError} from 'rxjs/operators';

import {UsersService} from '../services/users.service';
import {SubscriptionStatuses} from '../enums/subscriptionStatuses.enum';
import {SubscriptionViewModel} from '../viewModels/subscription.viewModel';

@Injectable()
export class PricingGuard implements CanActivate {
    constructor(private readonly usersService: UsersService, private readonly router: Router) {
    }

    canActivate() {
        // UNCOMMENT THIS ONLY IF WE WANT MASTER PROFILES TO BE WITHOUT SUBSCRIPTION (FREE)
        // if (window.location.href.includes('master/') || (this.usersService.userProfile && this.usersService.userProfile.is_master_profile === true)) {
        //     return true;
        // }

        return this.usersService.getUserSubscription().pipe(
            map(subscription => {
                if (subscription.status !== SubscriptionStatuses.CANCELLED) {
                    return true;
                } else {
                    this.router.navigate(['pricing']);

                    return false;
                }
            }),
            catchError(() => {
                this.router.navigate(['pricing']);

                return of(false);
            })
        );
    }
}
